// import { useEffect, useState } from 'react';
// import { useForm, useFieldArray, SubmitHandler } from 'react-hook-form';
// import { Product, ProductPayload } from '../../types';
// import { useBrandsStore, useIngredientsStore, useProblemsStore, useSkinTypesStore } from '../../store/adminStore';
// import { useCategoriesStore } from '../../store/categoriesStore';
// import { createProduct, createProductWithImages, uploadProductImages } from '../../services/productService';
// import { prepareRequestData } from '../../utils/productUtils';
// import Loader from '../loader/Loader';
// import ProductFormFields from './ProductFormFields';
// import ImageUpload from './ImageUpload';
// import ProductPreview from './ProductPreview';
// import Notification from '../toast/Notification';

// const AddProduct = () => {
//   const { categories, fetchCategories } = useCategoriesStore();
//   const { brands } = useBrandsStore();
//   const { ingredients } = useIngredientsStore();
//   const { problems } = useProblemsStore();
//   const { skinTypes } = useSkinTypesStore();

//   const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm<Product>();
//   const { fields, append, remove } = useFieldArray({ control, name: 'properties' });

//   const [images, setImages] = useState<File[]>([]);
//   const [coverIndex, setCoverIndex] = useState(0);
//   const [isLoading, setIsLoading] = useState(false);
//   const [productPreview, setProductPreview] = useState({
//     images: [] as string[],
//     name: '',
//     price: 0,
//     sku: '',
//     stock: 0,
//     description: '',
//   });
//   const [price, setPrice] = useState("");
//   const [searchBrands, setSearchBrands] = useState("");
//   const [notification, setNotification] = useState<{ text: string; status: "success" | "error" | "info" } | null>(null);

//   console.log(notification)
//   useEffect(() => {
//     fetchCategories().catch((error) => console.error('Ошибка загрузки категорий:', error));
//   }, [fetchCategories]);

//   const onSubmit: SubmitHandler<Product> = async (data) => {
//     if (images.length === 0) {
//       setNotification({ text: "Пожалуйста, добавьте хотя бы одно изображение.", status: "error" });
//       return;
//     }

//     setIsLoading(true);

//     try {
//       const preparedData = prepareRequestData(data);

//       const response = await createProductWithImages(preparedData, images, coverIndex);

//       setNotification({ text: `Товар "${response.product.name}" успешно создан!`, status: "success", });
//       // Сброс формы
//       reset({
//         name: '',
//         price: 0,
//         discount: 0,
//         stock: 0,
//         sku: '',
//         description: '',
//         brand_id: 0,
//         category_id: 0,
//         ingredients_ids: [],
//         problems_ids: [],
//         skin_types_ids: [],
//         properties: []
//     });
//       setImages([]);
//       setCoverIndex(0);
//       setPrice(""); // Сброс цены
//       setSearchBrands(""); // Сброс поля поиска бренда
//       setProductPreview({
//         images: [],
//         name: '',
//         price: 0,
//         sku: '',
//         stock: 0,
//         description: '',
//       });
//     } catch (error) {
//       console.error("Ошибка при создании товара:", error);
//       alert("Не удалось создать товар");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const updatePreview = (field: string, value: any) => {
//     setProductPreview((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   return (
//     <div className="p-4 max-w-4xl mx-auto">
//       <h1 className="text-2xl font-bold mb-4">Добавление нового товара</h1>
//       {isLoading && <Loader />}
//       {notification && <Notification text={notification.text} status={notification.status} duration={15000} />}
//       <form onSubmit={handleSubmit(onSubmit)} className="grid grid-cols-1 gap-6">
//         <ProductFormFields
//           register={register}
//           errors={errors}
//           control={control}
//           setValue={setValue}
//           fields={fields}
//           append={append}
//           remove={remove}
//           categories={categories}
//           brands={brands}
//           ingredients={ingredients}
//           problems={problems}
//           skinTypes={skinTypes}
//           price={price}
//           setPrice={setPrice}
//           searchBrands={searchBrands}
//           setSearchBrands={setSearchBrands}
//         />
//         <ImageUpload
//           images={images}
//           setImages={(newImages) => {
//             setImages(newImages);
//           }}
//           coverIndex={coverIndex}
//           setCoverIndex={setCoverIndex}
//         />
//         <button type="submit" className="bg-black text-white px-6 py-2 rounded hover:bg-blue-600">
//           Создать товар
//         </button>
//       </form>
//     </div>
//   );
// };

// export default AddProduct;

import { useEffect, useState } from "react";
import { useForm, useFieldArray, SubmitHandler, set } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { Product } from "../../types";
import { useCategoriesStore } from "../../store/categoriesStore";
import { useBrandsStore, useIngredientsStore, useProblemsStore, useSkinTypesStore } from "../../store/adminStore";
import { createProductWithImages } from "../../services/productService";
import { prepareRequestData } from "../../utils/productUtils";
import ProductFormFields from './ProductFormFields';
import ImageUpload, { ImageType } from "./ImageUpload";
// import ProductPreview from "./ProductPreview";
import Notification from "../toast/Notification";

import { Container, Paper, Typography, Button, CircularProgress } from "@mui/material";

const AddProduct = () => {
  const { categories, fetchCategories } = useCategoriesStore();
  const { brands } = useBrandsStore();
  const { ingredients } = useIngredientsStore();
  const { problems } = useProblemsStore();
  const { skinTypes } = useSkinTypesStore();
  const [searchParams] = useSearchParams();

  const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm<Product>();
  const { fields, append, remove } = useFieldArray({ control, name: "properties" });

  const [nameProduct, setNameProduct] = useState("");
  const [sku, setSku] = useState("");
  const [categoryId, setCategoryId] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [discount, setDiscount] = useState("");
  const [searchBrands, setSearchBrands] = useState("");
  const [images, setImages] = useState<ImageType[]>([]);
  const [coverIndex, setCoverIndex] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [notification, setNotification] = useState<{ id: number, text: string; status: "success" | "error" | "info" } | null>(null);

  useEffect(() => {
    fetchCategories().catch((error) => console.error("Ошибка загрузки категорий:", error));
  }, [fetchCategories]);

  // Предзаполнение формы из URL параметров
  useEffect(() => {
    const name = searchParams.get('name');
    const skuParam = searchParams.get('sku');
    const priceParam = searchParams.get('price');

    if (name) {
      setNameProduct(name);
      setValue('name', name);
    }
    if (skuParam) {
      setSku(skuParam);
      setValue('sku', skuParam);
    }
    if (priceParam) {
      const priceValue = parseFloat(priceParam);
      if (!isNaN(priceValue)) {
        setPrice(priceValue.toString());
        setValue('price', priceValue);
      }
    }
  }, [searchParams, setValue]);

  const onSubmit: SubmitHandler<Product> = async (data) => {
    if (images.length === 0) {
      setNotification({ id: Date.now(), text: "Пожалуйста, добавьте хотя бы одно изображение.", status: "error" });
      return;
    }

    setIsLoading(true);
    try {
      const preparedData = prepareRequestData(data);
      const response = await createProductWithImages(preparedData, images, coverIndex);
      setNotification({ id: Date.now(), text: `Товар "${response.product.name}" успешно создан!`, status: "success" });
      reset({
        name: "",
        price: 0,
        discount: undefined,
        // Убрали старые поля остатков - теперь используется система складов
        sku: "",
        description: "",
        brand_id: undefined,
        category_id: 0,
        ingredients_ids: [],
        problems_ids: [],
        skin_types_ids: [],
        properties: [],
      });
      setValue("category_id", 0);
      setDescription("");
      setCategoryId("");
      setImages([]);
      setCoverIndex(0);
      setPrice("");
      setSearchBrands("");
      setDiscount("");
      setNameProduct("");
      setSku("");
    } catch (error) {
      console.error("Ошибка при создании товара:", error);
      setNotification({ id: Date.now(), text: "Не удалось создать товар", status: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ padding: 3, marginTop: 4, marginBottom: 4 }}>
        <Typography variant="h5" gutterBottom>
          Добавление нового товара
        </Typography>
        {isLoading && <CircularProgress />}
        {notification && <Notification id={notification.id || Date.now()} text={notification.text} status={notification.status} duration={15000} />}
        <form onSubmit={handleSubmit(onSubmit)}>
          <ProductFormFields
            register={register}
            errors={errors}
            control={control}
            setValue={setValue}
            fields={fields}
            append={append}
            remove={remove}
            nameProduct={nameProduct}
            setNameProduct={setNameProduct}
            categories={categories}
            brands={brands}
            ingredients={ingredients}
            problems={problems}
            skinTypes={skinTypes}
            price={price}
            setPrice={setPrice}
            sku={sku}
            setSku={setSku}
            searchBrands={searchBrands}
            setSearchBrands={setSearchBrands}
            description={description}
            setDescription={setDescription}
            categoryId={categoryId}
            setCategoryId={setCategoryId}
            setDiscount={setDiscount}
            discount={discount}
          />
          <ImageUpload images={images} setImages={setImages} coverIndex={coverIndex} setCoverIndex={setCoverIndex} />
          <Button type="submit" variant="contained" color="primary" fullWidth sx={{ marginTop: 2 }}>
            Создать товар
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default AddProduct;